import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
    pageContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
      width: '100%',
      backgroundColor: theme.palette.backgroundV2.light,
    },
    headerSection: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(2, 5),
      backgroundColor: theme.palette.text.white,
      height: theme.spacing(4),
    },
    headerSectionV2: {
      display: 'flex',
      width: '100%',
      height: theme.spacing(8),
      padding: theme.spacing(1.5, 5),
      flexDirection: 'row' as const,
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: theme.palette.text.white,
      boxSizing: 'border-box' as const,
    },
    headerLeftV2: {
      display: 'flex',
      flexDirection: 'row' as const,
      alignItems: 'center',
      gap: theme.spacing(1.5),
    },
    headerNameArea: {
      display: 'flex',
      flexDirection: 'row' as const,
      alignItems: 'center',
      gap: theme.spacing(0.5),
    },
    headerOfferName: {
      color: theme.palette.labraText.primary,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.spacing(3),
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: theme.spacing(4),
    },
    headerOfferTypeBadge: {
      display: 'inline-flex',
      height: theme.spacing(3),
      padding: theme.spacing(0.5, 1.5),
      justifyContent: 'center',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      borderRadius: theme.spacing(2.5),
      border: '1px solid #2E3132',
      backgroundColor: theme.palette.text.white,
      fontSize: theme.spacing(1.5),
      fontFamily: theme.typography.fontFamily,
      color: '#2E3132',
      whiteSpace: 'nowrap' as const,
      fontWeight: 400,
      lineHeight: theme.spacing(2),
    },
    headerRightV2: {
      display: 'flex',
      flexDirection: 'row' as const,
      alignItems: 'center',
      gap: theme.spacing(1.5),
    },
    headerDownloadBtn: {
      display: 'flex',
      flexDirection: 'row' as const,
      justifyContent: 'center',
      alignItems: 'center',
      gap: theme.spacing(1),
      padding: theme.spacing(1, 2),
      borderRadius: theme.spacing(1),
      border: `1px solid ${theme.palette.dividerV2.main}`,
      backgroundColor: theme.palette.text.white,
      cursor: 'pointer',
      '&:hover': {
        opacity: 0.85,
      },
    },
    headerDownloadBtnText: {
      fontSize: theme.spacing(1.75),
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.labraText.primary,
      fontWeight: 400,
      lineHeight: theme.spacing(2.5),
      whiteSpace: 'nowrap' as const,
    },
    headerCloudIconWrap: {
      display: 'flex',
      width: theme.spacing(5),
      height: theme.spacing(5),
      flexDirection: 'column' as const,
      justifyContent: 'center',
      alignItems: 'center',
      gap: theme.spacing(1.25),
      flexShrink: 0,
    },
    headerLeft: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(2),
      padding: theme.spacing(0, 0.5),
    },
    backButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      color: theme.palette.primary.main,
      fontSize: theme.spacing(3),
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    offerInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
    },
    offerLabel: {
      fontSize: theme.spacing(1.5),
      color: theme.palette.labraText.description,
      lineHeight: '16px',
      fontFamily: theme.typography.fontFamily,
    },
    offerContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1.5),
    },
    offerNameContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(1.5),
    },
    offerChip: {
      height: theme.spacing(3),
      fontSize: theme.spacing(1.5),
    },
    headerRight: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(2),
    },
    quickMetering: {
      fontSize: `${theme.spacing(1.75)} !important`,
      fontWeight: '500 !important',
      lineHeight: '20px !important',
      fontFamily: `${theme.typography.fontFamily} !important`,
    },
    headerDivider: {
      width: theme.spacing(0.125),
      height: theme.spacing(3.5),
      backgroundColor: theme.palette.dividerV2.main,
      borderRadius: theme.spacing(0.5),
    },
    moreActions: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      color: theme.palette.primary.main,
      fontSize: theme.spacing(1.75),
      fontWeight: 500,
      cursor: 'pointer',
      '& svg': {
        width: theme.spacing(2),
        height: theme.spacing(2),
      },
    },
    offerHeader: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(2, 4),
      background: theme.palette.text.white,
      borderRadius: theme.spacing(1),
      height: theme.spacing(5.5),
    },
    offerHeaderLeft: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
    },
    offerLabelText: {
      fontSize: theme.spacing(1.5),
      color: theme.palette.labraText.description,
      lineHeight: theme.spacing(2),
    },
    offerName: {
      fontSize: theme.spacing(2) + ' !important',
      fontWeight: 500,
      lineHeight: '24px',
      color: theme.palette.text.primary,
      '&.MuiTypography-root': {
        fontSize: theme.spacing(2) + ' !important',
        fontWeight: 500,
        lineHeight: '24px',
        color: theme.palette.text.primary,
      },
    },
    resellerAuthChip: {
      height: theme.spacing(3),
      fontSize: theme.spacing(1.5),
      textAlign: 'center',
      borderColor: theme.palette.labraText.tertiary,
      color: theme.palette.labraText.tertiary,
      padding: theme.spacing(0.5, 0.5),
    },
    offerHeaderRight: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(2),
    },
    actionButton: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      cursor: 'pointer',
    },
    actionText: {
      fontSize: theme.spacing(1.75),
      fontWeight: 500,
      lineHeight: '20px',
      color: theme.palette.primary.main,
    },
    dividerLine: {
      width: theme.spacing(0.125),
      height: theme.spacing(3.5),
      backgroundColor: theme.palette.dividerV2.main,
      borderRadius: theme.spacing(0.5),
    },
    moreIcon: {
      width: theme.spacing(2),
      height: theme.spacing(2),
      color: theme.palette.primary.main,
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
      width: '100%',
    },
    boxShell: {
      width: '100%',
      marginTop: theme.spacing(2),
    },
    boxWrapper: {
      width: '100%',
      '& .box-heading-container': {
        padding: `${theme.spacing(4)} ${theme.spacing(4)} 0 ${theme.spacing(4)} !important`,
        width: `calc(100% - ${theme.spacing(8)}) !important`,
      },
    },
    /**
     * Contract details (Figma):
     * Expanded: 32px top/sides on heading, 0 bottom on heading + 24px body padding-top = 24px under title to values.
     * Collapsed: heading gets 32px bottom again when panel has .closed (stacked rows, image 3).
     * Collapsible shell: no padding; body hidden when closed to avoid 1px row borders / bleed.
     */
    contractDetailsBoxWrapper: {
      width: '100%',
      '& .box-heading-container': {
        padding: `${theme.spacing(4)} ${theme.spacing(4)} 0 ${theme.spacing(4)} !important`,
        width: '100% !important',
        boxSizing: 'border-box' as const,
      },
      '& [data-testid="box-container"]:has(> div:nth-of-type(2)[class*="closed"]) .box-heading-container':
        {
          paddingBottom: `${theme.spacing(4)} !important`,
        },
      '& [data-testid="box-container"] > div:nth-of-type(2)': {
        padding: '0 !important',
        minHeight: 0,
      },
      '& [data-testid="box-container"]:has(> div:nth-of-type(2)[class*="closed"]) > div:nth-of-type(2)':
        {
          overflow: 'hidden',
        },
      '& [data-testid="box-container"]:has(> div:nth-of-type(2)[class*="closed"]) [data-testid="contract-details-collapsible-body"]':
        {
          visibility: 'hidden',
          pointerEvents: 'none',
        },
    },
    headingIcon: {
      display: 'inline-flex',
      alignItems: 'center',
      '& svg': {
        width: theme.spacing(2.25),
        height: theme.spacing(2.25),
      },
    },
    sectionHeadingIconWrap: {
      width: theme.spacing(3.5),
      height: theme.spacing(3.5),
      borderRadius: theme.spacing(0.5),
      backgroundColor: theme.palette.bgSecondary.main,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    contractStatusCell: {
      display: 'flex',
      fontWeight: 400,
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(3),
    },
    daysLeftText: {
      fontSize: theme.spacing(2),
      fontWeight: 400,
      color: theme.palette.labraText.primary,
      fontFamily: theme.typography.fontFamily,
      lineHeight: '28px',
    },
    dateTimeContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(0.5),
    },
    paymentHeaderCell: {
      fontSize: theme.spacing(1.5),
      color: theme.palette.labraText.description,
      lineHeight: '16px',
      fontFamily: theme.typography.fontFamily,
      fontWeight: 500,
      flex: 1,
      textAlign: 'left' as const,
    },
    paymentCell: {
      fontSize: theme.spacing(1.75),
      color: theme.palette.labraText.tertiary,
      lineHeight: theme.spacing(2.5),
      fontFamily: theme.typography.fontFamily,
      flex: 1,
      textAlign: 'left' as const,
    },
    sectionContent: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      marginTop: theme.spacing(3),
    },
    sectionContentV2: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      paddingBottom: theme.spacing(1),
      '& [data-testid$="-value"]': {
        fontSize: theme.spacing(1.75),
        letterSpacing: theme.spacing(0.0625),
        color: theme.palette.labraText.tertiary,
        lineHeight: theme.spacing(3),
      },
    },
    contractSectionContent: {
      '& [data-testid$="-value"]': {
        fontSize: theme.spacing(2),
      },
      '& [data-testid="detailed-row"]:first-of-type': {
        paddingTop: 0,
      },
    },
    /** paddingTop 24px = space from “Contract details” title row to first values; sides/bottom 32px (Figma) */
    contractDetailsBodyInner: {
      paddingTop: theme.spacing(3),
      paddingRight: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      paddingLeft: theme.spacing(4),
      width: '100%',
      boxSizing: 'border-box' as const,
    },
    productName: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(1),
    },

    currencySymbol: {
      fontSize: theme.spacing(1.75),
      color: theme.palette.labraText.description,
    },
    pricingSection: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(3, 0, 3, 0),
      borderBottom: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
      '&:last-of-type': {
        borderBottom: 'none',
        padding: theme.spacing(3, 0, 0, 0),
      },
    },
    pricingConfigBoxWrapper: {
      width: '100%',
      '& .box-heading-container': {
        padding: `${theme.spacing(4)} ${theme.spacing(4)} 0 ${theme.spacing(4)} !important`,
        width: '100% !important',
        boxSizing: 'border-box' as const,
      },
      '& [data-testid="box-container"] > div:nth-of-type(2)': {
        padding: '0 !important',
        minHeight: 0,
      },
    },
    pricingConfigBodyInner: {
      paddingTop: theme.spacing(3),
      paddingRight: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      paddingLeft: theme.spacing(4),
      width: '100%',
      boxSizing: 'border-box' as const,
    },
    pricingConfigContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: 0,
      width: '100%',
    },
    installmentsContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: 0,
      width: '100%',
      marginTop: theme.spacing(5),
      paddingBottom: theme.spacing(4),
    },
    buyerDetailsContent: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      paddingBottom: theme.spacing(1),
      '& [data-testid$="-value"]': {
        fontSize: theme.spacing(1.75),
        letterSpacing: theme.spacing(0.0625),
        color: theme.palette.labraText.tertiary,
        lineHeight: theme.spacing(3),
      },
    },
    buyerDetailInfo: {
      '&&': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme.spacing(2),
      },
    },
    pricingSectionV2: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      padding: 0,
      border: 'none',
    },
    pricingSectionSeparator: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      alignSelf: 'stretch',
      width: '100%',
      padding: `${theme.spacing(3)} 0`,
      boxSizing: 'border-box' as const,
    },
    pricingSectionSeparatorLine: {
      flex: 1,
      height: theme.spacing(0.125),
      borderRadius: theme.spacing(0.5),
      backgroundColor: '#E2E2E2',
    },
    pricingSectionMeteringWrap: {
      marginTop: 0,
    },
    billingMeteringSeparator: {
      display: 'flex',
      alignSelf: 'stretch',
      width: '100%',
      height: theme.spacing(0.125),
      borderRadius: theme.spacing(0.5),
      backgroundColor: '#E2E2E2',
      margin: `${theme.spacing(3)} 0`,
    },
    pricingTitle: {
      fontSize: theme.spacing(1.75),
      fontWeight: 500,
      color: theme.palette.labraText.primary,
      lineHeight: theme.spacing(2.5),
      letterSpacing: theme.spacing(0.1),
      fontFamily: theme.typography.fontFamily,
    },
    pricingContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
    },
    planRow: {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(4),
      alignItems: 'center',
      padding: theme.spacing(1.5, 0, 0, 0),
    },
    planName: {
      fontSize: theme.spacing(1.75),
      color: theme.palette.labraText.tertiary,
      lineHeight: '20px',
      fontFamily: theme.typography.fontFamily,
    },
    planDescription: {
      fontSize: theme.spacing(1.75),
      color: theme.palette.labraText.tertiary,
      lineHeight: '20px',
      fontFamily: theme.typography.fontFamily,
      width: '75%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    billingTermsRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(1.5, 0, 0, 0),
    },
    billingRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: theme.spacing(4),
      width: '100%',
      paddingTop: 0,
    },
    billingColumnV2: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
      flex: 1,
      minWidth: 0,
    },
    billingColumn: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
    },
    billingLabel: {
      fontSize: theme.spacing(1.5),
      color: theme.palette.labraText.description,
      lineHeight: theme.spacing(2),
      fontFamily: theme.typography.fontFamily,
    },
    billingValue: {
      fontSize: theme.spacing(1.75),
      fontWeight: 400,
      color: theme.palette.labraText.tertiary,
      lineHeight: theme.spacing(2.5),
      fontFamily: theme.typography.fontFamily,
    },
    billingValueV2: {
      color: theme.palette.labraText.tertiary,
      fontSize: theme.spacing(1.75),
      fontWeight: 400,
      lineHeight: theme.spacing(2.5),
      letterSpacing: theme.spacing(0.0625),
      fontFamily: theme.typography.fontFamily,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    productValue: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    productLinkIcon: {
      color: theme.palette.select.light,
      fontSize: theme.spacing(2),
      cursor: 'pointer',
      '&:hover': {
        opacity: 0.75,
      },
    },
    eulaValue: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    eulaSeparator: {
      color: theme.palette.labraText.tertiary,
      fontSize: theme.spacing(2),
      lineHeight: theme.spacing(3),
    },
    meteringBox: {
      marginTop: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
      backgroundColor: theme.palette.text.white,
      borderRadius: theme.spacing(1),
      padding: theme.spacing(3),
      border: `1px solid ${theme.palette.dividerV2.main}`,
    },
    meteringTableV2: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 0,
      alignSelf: 'stretch',
      width: '100%',
    },
    meteringHeaderV2: {
      display: 'flex',
      flexDirection: 'row',
      paddingTop: 0,
      paddingBottom: theme.spacing(2),
      alignItems: 'flex-start',
      gap: theme.spacing(4),
      alignSelf: 'stretch',
      width: '100%',
      borderBottom: '1px solid #E2E2E2',
    },
    meteringRowV2: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: theme.spacing(4),
      alignSelf: 'stretch',
      width: '100%',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      borderBottom: '1px solid #E2E2E2',
      '&:last-of-type': {
        borderBottom: 'none',
        paddingBottom: 0,
      },
    },
    meteringHeaderCellV2: {
      fontSize: theme.spacing(1.5),
      color: theme.palette.labraText.description,
      lineHeight: '16px',
      fontFamily: theme.typography.fontFamily,
      fontWeight: 500,
      flex: 1,
      textAlign: 'left' as const,
    },
    meteringCellV2: {
      fontSize: theme.spacing(1.75),
      fontWeight: 400,
      color: theme.palette.labraText.tertiary,
      letterSpacing: theme.spacing(0.0625),
      lineHeight: theme.spacing(2.5),
      fontFamily: theme.typography.fontFamily,
      flex: 1,
      textAlign: 'left' as const,
    },
    meteringTable: {
      display: 'flex',
      flexDirection: 'column',
      paddingTop: theme.spacing(1.5),
    },
    meteringHeader: {
      display: 'flex',
      gap: theme.spacing(0.5),
      flexDirection: 'row',
      paddingBottom: theme.spacing(1),
      borderBottom: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    meteringHeaderCell: {
      fontSize: theme.spacing(1.5),
      color: theme.palette.labraText.description,
      lineHeight: '16px',
      fontFamily: theme.typography.fontFamily,
      flex: 1,
      textAlign: 'center',
      '&:first-of-type': {
        textAlign: 'left',
      },
      '&:last-of-type': {
        textAlign: 'right',
      },
    },
    meteringRow: {
      display: 'flex',
      gap: theme.spacing(0.5),
      flexDirection: 'row',
      padding: theme.spacing(1.5, 0),
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
      '&:last-of-type': {
        borderBottom: 'none',
      },
    },
    meteringCell: {
      fontSize: theme.spacing(2),
      color: theme.palette.labraText.tertiary,
      letterSpacing: theme.spacing(0.0625),
      lineHeight: '24px',
      fontFamily: theme.typography.fontFamily,
      flex: 1,
      textAlign: 'center',
      '&:first-of-type': {
        textAlign: 'left',
      },
      '&:last-of-type': {
        textAlign: 'right',
      },
    },
    meteringValue: {
      fontSize: theme.spacing(2),
      color: theme.palette.labraText.tertiary,
      letterSpacing: theme.spacing(0.0625),
      lineHeight: '24px',
      fontFamily: theme.typography.fontFamily,
      flex: 1,
      textAlign: 'center',
      '&:first-of-type': {
        textAlign: 'left',
      },
      '&:last-of-type': {
        textAlign: 'right',
      },
    },
    divider: {
      width: '100%',
      height: theme.spacing(0.125),
      backgroundColor: theme.palette.dividerV2.main,
      margin: theme.spacing(1.5, 0),
    },
    eulaLink: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(1),
      color: theme.palette.textField.dark,
      fontSize: theme.spacing(1.75),
      fontWeight: 500,
    },
    eulaDownloadSection: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(0.75),
      cursor: 'pointer',
    },
    eulaFileName: {
      color: theme.palette.select.light,
      fontSize: theme.spacing(1.75),
      fontWeight: 500,
      fontFamily: 'Poppins',
      cursor: 'pointer',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    downloadIcon: {
      color: theme.palette.select.light,
      fontSize: theme.spacing(2),
      cursor: 'pointer',
    },
    gridContainer: {
      padding: theme.spacing(4, 5),
    },
    leftColumn: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
    },
    rightColumn: {
      width: '30%',
      minWidth: theme.spacing(37.5),
    },
    stickyRightSection: {
      position: 'sticky',
      top: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
    },
    videoWrapper: {
      backgroundColor: theme.palette.text.white,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: theme.spacing(2),
      gap: theme.spacing(2),
      borderRadius: theme.spacing(1),
      width: '100%',
      maxHeight: theme.spacing(29.875),
      alignSelf: 'center',
    },
    videoContainer: {
      width: 'fit-content',
      textAlign: 'left',
      display: 'flex',
    },
    thumbnailWrapper: {
      position: 'relative',
      display: 'inline-block',
    },
    thumbnailImages: {
      width: theme.spacing(30),
      height: theme.spacing(16.875),
      cursor: 'pointer',
      borderRadius: theme.spacing(0.5),
    },
    playButton: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      color: theme.palette.primary.main,
      cursor: 'pointer',
      fontSize: theme.spacing(4.75),
      opacity: 0.9,
      '&:hover': {
        opacity: 1,
      },
    },
    activityLogContainer: {
      backgroundColor: theme.palette.text.white,
      borderRadius: theme.spacing(1),
      padding: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    activityLogHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    activityLogIconContainer: {
      width: theme.spacing(3.5),
      height: theme.spacing(3.5),
      borderRadius: theme.spacing(0.5),
      background: theme.palette.bgSecondary.main,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    activityLogTitle: {
      fontSize: theme.spacing(2),
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '24px',
      letterSpacing: '0.15px',
      color: theme.palette.labraText.primary,
      fontFamily: theme.typography.fontFamily,
    },
    activityLogContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(4),
      minHeight: theme.spacing(15),
    },
    activityLogEmpty: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    activityLogEmptyIcon: {
      color: theme.palette.labraText.description,
      fontSize: theme.spacing(3),
    },
    activityLogEmptyText: {
      fontSize: theme.spacing(1.75),
      color: theme.palette.labraText.description,
      textAlign: 'center',
      fontFamily: theme.typography.fontFamily,
    },
    // Placeholder styles for activity log and video
    placeholderCard: {
      backgroundColor: theme.palette.text.white,
      borderRadius: theme.spacing(1),
      padding: theme.spacing(4),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
      height: theme.spacing(31.75),
      width: '100%',
    },
    placeholderHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1.5),
    },
    placeholderIconContainer: {
      width: theme.spacing(3.5),
      height: theme.spacing(3.5),
      borderRadius: theme.spacing(0.5),
      backgroundColor: theme.palette.bgSecondary.main,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    placeholderTitle: {
      fontSize: theme.spacing(2),
      fontWeight: 500,
      lineHeight: '24px',
      letterSpacing: '0.15px',
      color: theme.palette.labraText.primary,
      fontFamily: theme.typography.fontFamily,
    },
    placeholderContent: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    placeholderGraphic: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    placeholderImage: {
      opacity: 0.18,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    headerContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flexStart',
      gap: theme.spacing(4),
      padding: theme.spacing(2, 5),
      backgroundColor: theme.palette.text.white,
      boxShadow: `0px -${theme.spacing(0.125)} 0px 0px ${theme.palette.labraV2BoxShadow.dark} inset`,
      position: 'sticky',
      zIndex: 99,
      top: 0,
    },
    appTitleHeading: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width: 'fit-content',
    },
    appBackIcon: {
      display: 'flex',
      margin: 'auto',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    },
    appTitleHeadingText: {
      fontSize: theme.spacing(3),
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '36px',
      color: theme.palette.labraText.primary,
    },
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      borderRadius: theme.spacing(1),
      padding: theme.spacing(5),
      background: theme.palette.bg.main,
      boxSizing: 'border-box' as const,
      margin: theme.spacing(4),
    },
    title: {
      alignItems: 'flex-start',
      fontWeight: 500,
      fontSize: theme.spacing(2),
      lineHeight: '24px',
      color: theme.palette.labraText.primary,
    },
    gridDiv: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(5),
    },
    subscriptionGridLeftUp: {
      border: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
      borderRadius: `${theme.spacing(0.5)} 0px 0px 0px`,
      borderRight: 0,
      borderBottom: 0,
      display: 'inline-flex',
      alignItems: 'center',
      height: theme.spacing(12.5),
    },
    subscriptionGridRightUp: {
      border: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
      borderRadius: `0px ${theme.spacing(0.5)} 0px 0px`,
      borderBottom: 0,
      display: 'inline-flex',
      alignItems: 'center',
      height: theme.spacing(12.5),
    },
    subscriptionGridBottomLeft: {
      border: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
      borderRadius: `0px 0px 0px ${theme.spacing(0.5)}`,
      borderRight: 0,
      display: 'inline-flex',
      alignItems: 'center',
      height: theme.spacing(12.5),
    },
    subscriptionGridBottomCenter: {
      border: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
      borderRadius: 0,
      borderRight: 0,
      display: 'inline-flex',
      alignItems: 'center',
      height: theme.spacing(12.5),
    },
    subscriptionGridBottomRight: {
      border: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
      borderRadius: `0px 0px ${theme.spacing(0.5)} 0px`,
      display: 'inline-flex',
      alignItems: 'center',
      height: theme.spacing(12.5),
    },
    staticGridLeft: {
      border: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
      borderRadius: `${theme.spacing(0.5)} 0px 0px ${theme.spacing(0.5)}`,
      borderRight: 0,
      display: 'inline-flex',
      alignItems: 'center',
      height: theme.spacing(12.5),
    },
    staticGridRight: {
      border: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
      borderRadius: `0px ${theme.spacing(0.5)} ${theme.spacing(0.5)} 0px`,
      display: 'inline-flex',
      alignItems: 'center',
      height: theme.spacing(12.5),
    },
    offerGridLeftUp: {
      border: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
      borderRadius: `${theme.spacing(0.5)} 0px 0px 0px`,
      borderRight: 0,
      borderBottom: 0,
      display: 'inline-flex',
      alignItems: 'center',
      height: theme.spacing(12.5),
    },
    offerGridLeftBottom: {
      border: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
      borderRadius: `0px 0px 0px ${theme.spacing(0.5)}`,
      borderRight: 0,
      display: 'inline-flex',
      alignItems: 'center',
      height: theme.spacing(12.5),
    },
    offerGridRightUp: {
      border: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
      borderRadius: `0px ${theme.spacing(0.5)} 0px 0px`,
      borderBottom: 0,
      display: 'inline-flex',
      alignItems: 'center',
      height: theme.spacing(12.5),
    },
    offerGridRightBottom: {
      border: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
      borderRadius: `0px 0px ${theme.spacing(0.5)} 0px`,
      display: 'inline-flex',
      alignItems: 'center',
      height: theme.spacing(12.5),
    },
    eulaDiv: {
      paddingTop: theme.spacing(2),
    },
    eulaGrid: {
      border: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
      borderRadius: theme.spacing(0.5),
      display: 'inline-flex',
      alignItems: 'center',
      height: theme.spacing(12.5),
    },
    section: {
      padding: theme.spacing(2, 0),
      marginBottom: theme.spacing(2),
    },
    svgBackground: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: theme.spacing(45),
    },
    activityLogWidth: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
      overflowY: 'auto',
      maxHeight: '90vh',
    },
    rootContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: theme.spacing(31.75),
      gap: theme.spacing(3),
      backgroundColor: theme.palette.text.white,
      borderRadius: theme.spacing(1),
      padding: theme.spacing(4),
    },
    titleIconContainer: {
      display: 'flex',
      height: theme.spacing(3.5),
      width: theme.spacing(3.5),
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: theme.spacing(1.25),
      backgroundColor: theme.palette.bgSecondary.main,
      borderRadius: theme.spacing(0.5),
    },
    titleIcon: {
      color: theme.palette.labraText.primary,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 500,
      padding: theme.spacing(0, 1),
    },
    titleContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1.5),
      marginBottom: theme.spacing(3),
    },
    heading: {
      fontSize: theme.spacing(2),
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '24px',
      color: theme.palette.labraText.primary,
      fontFamily: 'Poppins, sans-serif',
      letterSpacing: '0.15px',
    },
    labraIcon: {
      height: theme.spacing(9.75),
      width: theme.spacing(26.75),
    },
    labraLogoContainer: {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(1.5),
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
    },
    labraLogo: {
      width: theme.spacing(14),
      height: theme.spacing(11),
    },
    activityHeading: {
      marginTop: theme.spacing(2),
      fontSize: theme.spacing(1.75),
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',
      color: theme.palette.textField.main,
      fontFamily: theme.typography.fontFamily,
      letterSpacing: '0.25px',
    },
    paymentScheduleTable: {
      display: 'flex',
      flexDirection: 'column',
    },
    paymentScheduleTableV2: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 0,
      alignSelf: 'stretch',
      width: '100%',
    },
    paymentScheduleHeaderV2: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      paddingTop: 0,
      paddingBottom: theme.spacing(2),
      borderBottom: '1px solid #E2E2E2',
    },
    paymentScheduleRowV2: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      alignItems: 'center',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      borderBottom: '1px solid #E2E2E2',
      '&:last-of-type': {
        borderBottom: 'none',
        paddingBottom: 0,
      },
    },
    paymentScheduleHeader: {
      display: 'flex',
      flexDirection: 'row',
      padding: theme.spacing(1.5, 0),
      borderBottom: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
    },
    paymentScheduleHeaderCell: {
      fontSize: theme.spacing(1.5),
      color: theme.palette.labraText.description,
      lineHeight: '16px',
      fontFamily: theme.typography.fontFamily,
      fontWeight: 500,
      '&:first-of-type': {
        width: '50%',
        textAlign: 'left',
      },
      '&:last-of-type': {
        textAlign: 'left',
      },
    },
    paymentScheduleRow: {
      display: 'flex',
      flexDirection: 'row',
      padding: theme.spacing(1.5, 0),
      alignItems: 'center',
      '&:not(:last-child)': {
        borderBottom: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
      },
    },
    paymentScheduleCell: {
      fontSize: theme.spacing(2),
      color: theme.palette.labraText.tertiary,
      lineHeight: '20px',
      fontFamily: theme.typography.fontFamily,
      '&:first-of-type': {
        width: '50%',
        textAlign: 'left',
      },
      '&:last-of-type': {
        textAlign: 'left',
      },
    },
    subscriptionSummarySection: {
      display: 'flex',
      flexDirection: 'column' as const,
      width: '100%',
      padding: theme.spacing(3),
      gap: theme.spacing(3),
      borderRadius: theme.spacing(1),
      overflow: 'hidden',
      border: `1px solid ${theme.palette.dividerV2.main}`,
      backgroundColor: theme.palette.text.white,
      boxSizing: 'border-box' as const,
    },
    subscriptionSummarySectionEnded: {
      backgroundColor: '#FFFFFF',
      borderColor: theme.palette.dividerV2.main,
    },
    gcpBannerTheme: {
      '--gcp-banner-background': '#FFDFC6',
      '--gcp-banner-status-chip': '#00820D',
    },
    gcpBannerThemeActive: {
      '--gcp-banner-background': '#FFDFC6',
      '--gcp-banner-status-chip': '#00820D',
    },
    gcpBannerThemeEndingSoon: {
      '--gcp-banner-background': '#FFDFC6',
      '--gcp-banner-status-chip': '#C55B02',
    },
    gcpBannerThemeEnded: {
      '--gcp-banner-background': '#FFDAD6',
      '--gcp-banner-status-chip': '#BA1A1A',
    },
    bannerContent: {
      display: 'flex',
      flexDirection: 'row' as const,
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: theme.spacing(2),
      width: '100%',
      minWidth: 0,
    },
    bannerCreateOfferBtn: {
      display: 'flex',
      flexDirection: 'row' as const,
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      gap: theme.spacing(1),
      width: theme.spacing(16.75),
      height: theme.spacing(5),
      border: `1px solid ${theme.palette.labraText.primary}`,
      borderRadius: theme.spacing(0.5),
      backgroundColor: theme.palette.text.white,
      flexShrink: 0,
      '&:hover': {
        opacity: 0.85,
      },
    },
    bannerCreateOfferBtnText: {
      fontSize: theme.spacing(1.75),
      fontWeight: 500,
      lineHeight: theme.spacing(2.5),
      color: theme.palette.labraText.primary,
      whiteSpace: 'nowrap' as const,
    },
    statusBannerText: {
      fontSize: theme.spacing(1.75),
      color: theme.palette.labraText.primary,
      lineHeight: theme.spacing(2.5),
    },
    actionsRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      padding: 0,
      backgroundColor: theme.palette.text.white,
      borderRadius: 0,
      width: '100%',
      boxSizing: 'border-box' as const,
    },
    actionButtonV2: {
      display: 'flex',
      flexDirection: 'row' as const,
      alignItems: 'center',
      gap: theme.spacing(0.5),
      cursor: 'pointer',
      padding: theme.spacing(0.5, 1),
      border: `${theme.spacing(0.125)} solid ${theme.palette.dividerV2.main}`,
      borderRadius: theme.spacing(0.5),
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: theme.palette.backgroundV2.light,
      },
    },
    actionButtonText: {
      fontSize: theme.spacing(1.75),
      fontWeight: 500,
      lineHeight: theme.spacing(2.5),
      color: theme.palette.labraText.primary,
    },
    customStatusChip: {
      backgroundColor: theme.palette.common.white,
      textAlign: 'center',
      border: `${theme.spacing(0.125)} solid`,
      borderRadius: theme.spacing(2.5),
      fontWeight: 400,
      padding: theme.spacing(0.5),
      height: theme.spacing(3),
      display: 'inline-flex',
      alignItems: 'center',
      fontSize: theme.spacing(1.5),
      lineHeight: theme.spacing(2),
    },
    createdAtDate: {
      fontSize: theme.spacing(2),
      color: theme.palette.labraText.tertiary,
      lineHeight: theme.spacing(3),
    },
    createdAtTime: {
      fontSize: theme.spacing(1.75),
      color: theme.palette.labraText.description,
      lineHeight: theme.spacing(2.5),
    },
  })
)

export const BOX_COLLAPSIBLE_STYLE_V2 = {
  paddingLeft: '32px',
  paddingRight: '32px',
  width: '100%',
  boxSizing: 'border-box' as const,
}

/** Pricing configuration: same as contract — no padding on collapsible root; use pricingConfigBodyInner */
export const PRICING_CONFIG_COLLAPSIBLE_STYLE_V2 = {
  padding: 0,
  width: '100%',
  boxSizing: 'border-box' as const,
}

/** No padding on collapsible root — padding on inner (contractDetailsBodyInner) so collapse hides fully */
export const CONTRACT_DETAILS_COLLAPSIBLE_STYLE_V2 = {
  padding: 0,
  width: '100%',
  boxSizing: 'border-box' as const,
}

export const INSTALLMENTS_COLLAPSIBLE_STYLE_V2 = BOX_COLLAPSIBLE_STYLE_V2
